import script from "./SubscriptionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionManagement.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionManagement.vue?vue&type=style&index=0&id=991e427a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-991e427a"]])

export default __exports__